<template>
  <DataTable :value="rows" data-key="key" :show-gridlines="true">
    <Column field="leftValue" bodyStyle="text-align:right">
      <template #body="{ data }">
        {{ formatNumber(data.leftValue) }}
      </template>
    </Column>
    <Column field="rightValue" bodyStyle="text-align:right">
      <template #body="{ data }">
        {{ formatNumber(data.rightValue) }}
      </template>
    </Column>
    <Column
      field="difference"
      :header="t('labels.difference')"
      headerStyle="text-align:right"
      bodyStyle="text-align:right"
    >
      <template #body="{ data }">
        {{ formatNumber(data.difference) }}
      </template>
    </Column>
  </DataTable>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import Column from 'primevue/column';
import DataTable from 'primevue/datatable';
import { useI18n } from 'vue-i18n';

import { formatNumber } from '@/utils/number';

import type { OperatingCostInvoiceLineItemSimple } from '../operatingCostInvoiceTypes';

const props = defineProps<{
  costsNet?: number;
  statedCustomerPrepaymentNet?: number;
  settlementResultNet?: number;
  customerPrepaymentGross?: number;
  lineItems?: OperatingCostInvoiceLineItemSimple[];
}>();

const { t } = useI18n();

const sumCustomerAmountFromLineItems = computed(() => {
  return props.lineItems?.reduce((sum, item) => sum + (item.customerAmount ?? 0), 0) ?? 0;
});

const customerPrepaymentForComparison = computed(() => {
  return props.customerPrepaymentGross ?? 0;
});

const settlementFromFormula = computed(() => {
  return sumCustomerAmountFromLineItems.value - customerPrepaymentForComparison.value;
});

const rows = computed(() => {
  return [
    {
      key: 'costs-net',
      leftValue: props.costsNet ?? 0,
      rightValue: sumCustomerAmountFromLineItems.value,
      difference: sumCustomerAmountFromLineItems.value - (props.costsNet ?? 0),
    },
    {
      key: 'stated-customer-prepayment-net',
      leftValue: props.statedCustomerPrepaymentNet ?? 0,
      rightValue: customerPrepaymentForComparison.value,
      difference: customerPrepaymentForComparison.value - (props.statedCustomerPrepaymentNet ?? 0),
    },
    {
      key: 'settlement-result-net',
      leftValue: props.settlementResultNet ?? 0,
      rightValue: settlementFromFormula.value,
    },
  ];
});
</script>
